module.exports = __webpack_public_path__ + "img/symbol_10.f27f9b11.png";